import { A, Div, Icon, Section, Table } from "trunx";
import { LeafletPanelBody, LeafletPanelHeading } from "../shared/LeafletPanel";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ISensor } from "../models/Sensors";
import { observer } from "mobx-react-lite";
import { useLocaleContext } from "../contexts/LocaleContext";
import { useRootStore } from "../models/Root";

const BookmarksPanel = () => {
  const {
    dict: {
      panel: { bookmarks: dict },
    },
  } = useLocaleContext();

  const {
    menus: { closePanel },
    sensors: { setSensor, bookmarkedSensors },
  } = useRootStore();

  const Row = ({ sensor }: { sensor: ISensor }) => {
    const onClick = () => {
      setSensor(sensor);
    };

    const { id, humanId, site } = sensor;

    return (
      <tr key={id}>
        <td>
          <A bulma="has-text-left" onClick={onClick}>
            {site}
          </A>
        </td>
        <td>
          <A bulma="has-text-right" onClick={onClick}>
            {humanId || '&nbsp'}
          </A>
        </td>
      </tr>
    );
  };

  const table =
    bookmarkedSensors.length > 0 ? (
      <Table bulma="is-fullwidth">
        <tbody>
          <tr>
            <th>{dict.name}</th>
            <th colSpan={2}>ID</th>
          </tr>

          {bookmarkedSensors.map((s) => (
            <Row sensor={s}></Row>
          ))}
        </tbody>
      </Table>
    ) : (
      <Section bulma="has-text-centered">
        <i className="has-text-centered">No bookmarks, click</i>
        <Icon>
          <FontAwesomeIcon icon={["far", "star"]} />
        </Icon>
        <i> to add one.</i>
      </Section>
    );

  return (
    <Div bulma="panel">
      <Div bulma="panel-heading">
        <LeafletPanelHeading title={dict.title} close={closePanel} />
      </Div>

      <LeafletPanelBody>
        <Section>{table}</Section>
      </LeafletPanelBody>
    </Div>
  );
};

export default observer(BookmarksPanel);
